import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from '@progress/kendo-angular-l10n';
import { User } from 'src/app/global-functions';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
    selector: 'app-versoes-component',
    templateUrl: './versoes.component.html'
})
export class VersoesComponent implements OnInit {
    public versaoBackend: string = '';
    public versaoWeb: string = '1.2.6.2'; // Será atualizado pelo script
    public customMsgService: CustomMessagesService;
    public mostrarVersoes: boolean = true;

    constructor(
        private router: Router,
        private api: ApiService,
        public msgService: MessageService
    ) {
        this.customMsgService = this.msgService as CustomMessagesService;
    }

    ngOnInit(): void {
        this.carregarversaoBackend();
    }

    private carregarversaoBackend(): void {
        var user = User.userInSession();
        console.log(user);
        if (user && Object.keys(user).length > 0) {
            this.api.getRequest("Utils/GetVersion")
                .then((data: any) => {
                    this.versaoBackend = data.value;
                })
                .catch((err) => {
                    console.error('Erro ao obter a versão da API:', err);
                });
            this.mostrarVersoes = false;
        } else {
            this.mostrarVersoes = true;
        }
    }
}